import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../utils/api';
import { CheckCircle, XCircle, Loader, Music } from 'lucide-react';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); setMsg('Token mancante'); return; }
    (async () => {
      try {
        const { data } = await api.post('/auth/verify-email', { token });
        setStatus('success'); setMsg(data.message);
      } catch (err) {
        setStatus('error'); setMsg(err.response?.data?.error || 'Errore verifica');
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen bg-[#1A1A2E] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#E94560] mb-4"><Music size={28} className="text-white" /></div>
        {status === 'loading' && <><Loader size={48} className="mx-auto text-gray-400 animate-spin mb-4" /><p className="text-gray-500">Verifica in corso...</p></>}
        {status === 'success' && <><CheckCircle size={48} className="mx-auto text-green-500 mb-4" /><h2 className="text-xl font-bold text-pn-dark mb-2">Email Verificata!</h2><p className="text-gray-500 mb-6">{msg}</p><Link to="/login" className="btn-primary inline-block">Vai al Login</Link></>}
        {status === 'error' && <><XCircle size={48} className="mx-auto text-red-500 mb-4" /><h2 className="text-xl font-bold text-pn-dark mb-2">Errore</h2><p className="text-gray-500 mb-6">{msg}</p><Link to="/login" className="btn-secondary inline-block">Torna al Login</Link></>}
      </div>
    </div>
  );
}
